import { FormFieldDescriptions } from "../components/Proposal/Models/IFieldDescription";
import { IProposal } from "../components/Proposal/Models/IProposal";
import enStrings from "../loc/en-us";
export default class CommonService {
    public static getLabelForField =
        (fieldKey: string, formFieldDescriptions: FormFieldDescriptions): string => {
            const defaultValue = enStrings[fieldKey];
            let label = CommonService.getFieldInfoFromFieldDescriptionObject(formFieldDescriptions, fieldKey, 'Label');
            if (!label)
                label = defaultValue ? defaultValue : fieldKey;
            return label;
        }
    public static getFieldInfoFromFieldDescriptionObject =
        (fieldDescriptions: FormFieldDescriptions, fieldName: string, propertyToGet: 'Description' | 'Label' | 'Placeholder') => {
            return fieldDescriptions?.[fieldName]?.[propertyToGet] || '';
        }
    public static checkIfNeodantBrand = (proposal: IProposal) => {
        return proposal?.brand?.toLowerCase() === "neodent";
    }
}